import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexLeaflet',
  setup(__props) {

let Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const SimpleMap = defineAsyncComponent(() => import("@/components/theme/maps/SimpleMap.vue"))
const MultiLanguage = defineAsyncComponent(() => import("@/components/theme/maps/MultiLanguage.vue"))
const MultiLanguage2 = defineAsyncComponent(() => import("@/components/theme/maps/MultiLanguage2.vue"))
let desc = ref<string>("Display a map with labels in a foreign language")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Simple Map",
        headerTitle: "true"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SimpleMap))
        ]),
        _: 1
      }),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Multi-language support",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MultiLanguage))
        ]),
        _: 1
      }, 8, ["desc"]),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-12",
        cardbodyClass: "map-z-index",
        title: "Multi-language support",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MultiLanguage2))
        ]),
        _: 1
      }, 8, ["desc"])
    ])
  ]))
}
}

})